import axios, { type AxiosResponse } from '@fs/zion-axios'
import { sgBaseUrl } from '@fs/zion-config'
import { ROOTSTECH_SERVICE as SERVICE } from '../../serviceNames'

const BASE = `${SERVICE}/rtc/storage`

const contentTypeMap: Record<string, string> = {
  mp4: 'video/mp4',
  mpeg: 'video/mpeg',
  qt: 'video/quicktime',
  mov: 'video/quicktime',
  webm: 'video/webm',
}

function fixedEncodeURIComponent(uriComponent: string): string {
  // NOTE: escapes apostrophe, then properly encodes that character.
  return encodeURIComponent(uriComponent).replaceAll(/[!'()*]/g, (char) => {
    return `%${(char.codePointAt(0) ?? 0).toString(16)}`
  })
}

export const requestUploadUrl = async (cmsId: string, fileName: string): Promise<AxiosResponse> => {
  const extension = fileName.split('.').at(-1) ?? ''
  const options = { headers: { 'Content-Type': contentTypeMap[extension] } }

  return axios.put(`${BASE}/uploads/${cmsId}/${fixedEncodeURIComponent(fileName)}`, {}, options)
}

export const getS3Url = (sessionId: string, fileName: string): string => {
  return `${sgBaseUrl}${BASE}/uploads/${sessionId}/${fixedEncodeURIComponent(fileName)}`
}
